import React from "react";

// import "./H2HTable.scss";
import NextImage from "../NextImage";
import { getImageUrl, getMatchOutcome } from "../../../utils/generalLiveCenter";
import { DateUtility } from "../../../utils/dateUtility";
import NoDataFound from "../NoDataFound";

const H2HTable = ({
  team,
  data,
  plays = false,
  team_id,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  liveCentre,
  sport = 'football'
}) => {
  const getMatchOutcomeClass = (team_id, match) => {
    const outcome = getMatchOutcome(team_id, match);
    let outcomeClass;

    if (outcome === "W") {
      outcomeClass = "win";
    } else if (outcome === "L") {
      outcomeClass = "loss";
    } else {
      outcomeClass = "draw";
    }

    return outcomeClass;
  };
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";
  const navigateToLeaguePage = (leagueId) => {
    if (liveCentre) {
      setHead("league");
      setDataId(leagueId);
      setDataType("league-page");
      setLeagueId(leagueId);
    }
  };

  const navigateToMatchPage = (matchId) => {
    if (liveCentre) {
      setHead("match");
      setDataId(matchId);
      setDataType("match-page");
    }
  };
  return (
    <div className="h2h_wrp_boxs">
      {data?.length ? (
        data?.map((league, leagueIdx) => (
          <div className="h2h_wrp_box" key={league?.id || leagueIdx}>
            <div className="h2h_wrp_box_head">
              <div className="icon_wrap">
                <NextImage
                  src={`${baseURL}/public/assets/images/flags/country_${league?.fid}.png`}
                  width={18}
                  height={18}
                  alt="avatar"
                />
              </div>
              <div
                className="rgt"
                onClick={() => navigateToLeaguePage(league?.id)}
              >
                <span className="title">{`${league?.name} ${league?.sea}`}</span>

                <span className="countary">{league?.nm?.split("-")?.[0]}</span>
              </div>
            </div>
            <div className="global_table h2h_table">
              <table>
                <tbody>
                  {league?.matches.map((match) => {
                    const [homeScore, awayScore] = (
                      match?.ps ||
                      match?.ft ||
                      ""
                    ).split("-");
                    const isHomeActive =
                      parseInt(homeScore) > parseInt(awayScore);
                    const isAwayActive =
                      parseInt(homeScore) < parseInt(awayScore);

                    return (
                      <tr
                        key={match?.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => navigateToMatchPage(match?.id)}
                      >
                        <td>
                          <div className="match-timing">
                            <span className="match_date">
                              {DateUtility.FormatDateh2h(new Date(match?.dt))}
                            </span>
                            <span className="match_time ft">FT</span>
                          </div>
                        </td>
                        <td>
                          <div className="teams_wrap">
                            <div className="teams-name">
                              <span
                                className={`team_name ${isHomeActive ? "active" : ""
                                  }`}
                              >
                                <span className="teams-logo">
                                  <NextImage
                                    src={getImageUrl('', '', sport, match?.competitors?.htid)}
                                    height={18}
                                    width={18}
                                    alt="teamLogo"
                                    priority={false}
                                  />
                                </span>
                                {match?.competitors?.htn}
                              </span>
                              <span
                                className={`team_name ${isAwayActive ? "active" : ""
                                  }`}
                              >
                                <span className="teams-logo">
                                  <NextImage
                                    src={getImageUrl('', '', sport, match?.competitors?.atid)}

                                    height={18}
                                    width={18}
                                    alt="teamLogo"
                                    priority={false}
                                  />
                                </span>
                                {match?.competitors?.atn}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td className="score-td">
                          <div className="teams-name">
                            <strong className="highlighted-color">
                              {homeScore}
                            </strong>
                            <strong className="team_name highlighted-color">
                              {awayScore}
                            </strong>
                          </div>
                        </td>
                        {plays && (
                          <td className="win-td">
                            <div className="icon-wrap">
                              <span
                                className={`icon_status ${getMatchOutcomeClass(
                                  team_id,
                                  match
                                )}`}
                              >
                                {getMatchOutcome(team_id, match)}
                              </span>
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default H2HTable;
